import type { FaireProductEntity } from "../../entity_types/product";

export const p_zp37xzx8eb: FaireProductEntity = {
  token: "p_zp37xzx8eb",
  type: "product",
  name: "Minnesota State Shape Snowy Cardinal 4 Layer Wood Ornament",
  brandName: "Token Atelier",
  imageUrl:
    "https://cdn.faire.com/fastly/859b704e146ed892f15a2173aed03cf28579c4f43fe46a624e750f4e6540d842.png",
  priceDollars: 4.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/03d3ee1fb5f434e6df17e7dc1c736a1495b095d51c2a1be7cbc7853a2ab739fc.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
